import Swiper from 'swiper'

new Swiper('.slider-design', {
    slidesPerView: 'auto',
    spaceBetween: 40,
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
    },
    breakpoints: {
        300: {
            spaceBetween: 24,
        },
        1280: {
            spaceBetween: 40,
        },
    },
  })